export default __webpack_public_path__ + "assets/models/35dec56c0b965368a0febf38920f8975.glb";